/* import __COLOCATED_TEMPLATE__ from './category-filter.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';
import type { GuidelineCategory } from 'embercom/models/ai-agent/guidelines';

interface Args {
  activeFilter?: string;
  categories: Array<{
    id: GuidelineCategory;
    title: string;
    description: string;
    icon: InterfaceIconName;
  }>;
  selectedCategories?: GuidelineCategory[];
  onFilterChange: (categories: GuidelineCategory[]) => void;
}

const NUMBER_OF_CATEGORIES_TO_DISPLAY = 2;

export default class CategoryFilter extends Component<Args> {
  @service intl!: IntlService;

  get isOpen() {
    return this.args.activeFilter === 'category' && !this.args.selectedCategories?.length;
  }

  get items() {
    let items = this.args.categories.map((category) => {
      return {
        text: category.title,
        icon: category.icon,
        value: category.id,
        isSelected: this.args.selectedCategories?.includes(category.id),
      };
    });

    return [{ items }];
  }

  get selectedCategoryText() {
    if (this.args.selectedCategories && this.args.selectedCategories.length > 0) {
      if (this.args.selectedCategories.length > NUMBER_OF_CATEGORIES_TO_DISPLAY) {
        return this.intl.t('ai-agent.guidance.filters.category.display-selected-item-and-count', {
          selectedItems: this.selectedItemsToDisplay,
          count: this.args.selectedCategories.length - NUMBER_OF_CATEGORIES_TO_DISPLAY,
        });
      }
      return this.intl.t('ai-agent.guidance.filters.category.display-selected-items', {
        selectedItems: this.selectedItemsToDisplay,
      });
    }

    return this.intl.t('ai-agent.guidance.filters.category.any-category');
  }

  get selectedItemsToDisplay() {
    return this.args.selectedCategories
      ?.slice(0, NUMBER_OF_CATEGORIES_TO_DISPLAY)
      .map((categoryId) => {
        let category = this.args.categories.find((cat) => cat.id === categoryId);
        return category?.title || '';
      })
      .join(', ');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Guidance::CategoryFilter': typeof CategoryFilter;
    'ai-agent/guidance/category-filter': typeof CategoryFilter;
  }
}
